// @flow

import React from 'react'
import glamorous from 'glamorous'
import getContent from 'pp-react-l10n'
import { HeadingText, BodyText } from '@paypalcorp/pp-react'

import { ILLUSTRATIONS } from 'utils/constants'

const l10n = getContent('pages/error')

const Wrapper = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
})
const Container = glamorous.div({
  margin: '5rem 0',
  maxWidth: '21rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
})

const Warning = glamorous.img({
  width: '7rem',
  height: '7rem',
})

const HeaderContainer = glamorous.div({
  marginTop: '0.5rem',
})
const BodyContainer = glamorous.div({
  marginTop: '2rem',
})

function SlugNotFound() {
  return (
    <Wrapper>
      <Container>
        <Warning src={ILLUSTRATIONS.WARNING} alt="" />
        <HeaderContainer>
          <HeadingText size="md" role="heading" aria-level="1">
            {l10n('error.title.slugDoesNotExist')}
          </HeadingText>
        </HeaderContainer>
        <BodyContainer>
          <BodyText>{l10n('error.subheader.slugDoesNotExist')}</BodyText>
        </BodyContainer>
      </Container>
    </Wrapper>
  )
}

export default SlugNotFound
